import { createContext, ReactNode, useContext } from 'react';

type FieldVisibility = 'AlwaysVisible' | 'AlwaysInvisible' | 'VisibleIfHasValue';

interface IFormControlContextValue {
    readonly?: boolean;
    disabled?: boolean;
    visibility?: FieldVisibility;
}

export const FormControlContext = createContext({} as IFormControlContextValue);

export const FormControlProvider = ({ value, children }: { value: IFormControlContextValue; children: ReactNode }) => {
    const oldValue = useContext(FormControlContext);

    return <FormControlContext.Provider value={{ ...oldValue, ...value }}>{children}</FormControlContext.Provider>;
};

export const useFieldsReadonly = (readonlyOverride: boolean | undefined): boolean => {
    const { readonly } = useContext(FormControlContext);

    return readonlyOverride ?? readonly ?? false;
};

/** A field is disabled when its own prop or the surrounding form says so; the form can't re-enable it. */
export const useFieldsDisabled = (disabled: boolean | undefined): boolean => {
    const { disabled: formDisabled } = useContext(FormControlContext);

    return Boolean(disabled) || Boolean(formDisabled);
};

export const useFieldVisibility = (visibilityOverride: FieldVisibility | undefined): FieldVisibility => {
    const { visibility } = useContext(FormControlContext);

    return visibilityOverride ?? visibility ?? 'AlwaysVisible';
};
